import { call, delay, put, takeEvery } from 'redux-saga/effects';

import { kycService } from '../../../services/kyc.service';

import { fetchProfileData } from '../../auth/profile/actions';
import { CHECK_KYC_STATUS, GET_VERIFICATION_LINK, UPDATE_PROFILE_AFTER_KYC } from './actionTypes';
import {
  checkKYCStatusFail,
  checkKYCStatusSuccess,
  getVerificationLinkFail,
  getVerificationLinkSuccess,
} from './actions';

function* getVerificationLinkSaga() {
  try {
    const response = yield call(kycService.getVerificationLink);
    console.log('KYC API Response:', response);
    if (response?.data?.form_url) {
      yield put(getVerificationLinkSuccess(response.data.form_url));
    } else {
      console.error('KYC API Response is missing form_url:', response);
      yield put(getVerificationLinkFail('Не удалось получить ссылку для верификации'));
    }
  } catch (error) {
    console.error('KYC Link Error:', error);
    yield put(
      getVerificationLinkFail(
        error?.response?.data?.message || 'Произошла ошибка при получении ссылки',
      ),
    );
  }
}

function* checkKYCStatusSaga() {
  try {
    yield put(fetchProfileData());
    yield delay(2000);
    yield put(checkKYCStatusSuccess());
  } catch (error) {
    console.error('KYC Status Check Error:', error);
    yield put(checkKYCStatusFail('Произошла ошибка при проверке статуса'));
  }
}

function* updateProfileAfterKYCSaga() {
  yield put(fetchProfileData());
}

function* kycSaga() {
  yield takeEvery(GET_VERIFICATION_LINK, getVerificationLinkSaga);
  yield takeEvery(CHECK_KYC_STATUS, checkKYCStatusSaga);
  yield takeEvery(UPDATE_PROFILE_AFTER_KYC, updateProfileAfterKYCSaga);
}

export default kycSaga;
